import React, { useEffect, useState } from 'react';
import { Paperclip } from '@phosphor-icons/react';
import { fetchAttachmentBlob } from '../api/whatsappTasksApi';

function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

function AttachmentPreview({ attachment }) {
  const [imageUrl, setImageUrl] = useState(null);
  const isImage = (attachment.mime_type || '').startsWith('image/');

  useEffect(() => {
    if (!isImage) return undefined;
    let objectUrl;
    fetchAttachmentBlob(attachment.url)
      .then((blob) => {
        objectUrl = URL.createObjectURL(blob);
        setImageUrl(objectUrl);
      })
      .catch(() => {});
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [attachment.url, isImage]);

  const handleDownload = async () => {
    try {
      const blob = await fetchAttachmentBlob(attachment.url);
      triggerDownload(blob, attachment.filename);
    } catch {
      // ignore — user can retry
    }
  };

  if (isImage) {
    return imageUrl ? (
      <img
        src={imageUrl}
        alt={attachment.filename}
        onClick={handleDownload}
        title={`${attachment.filename} (click to download)`}
        style={{ maxWidth: '220px', maxHeight: '220px', borderRadius: '8px', border: '1px solid #E5E7EB', cursor: 'pointer', display: 'block' }}
      />
    ) : (
      <span style={{ fontSize: '12px', color: '#9CA3AF' }}>Loading image…</span>
    );
  }

  return (
    <button
      type="button"
      onClick={handleDownload}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '6px 12px',
        fontSize: '12px', border: '1px solid #E5E7EB', borderRadius: '6px', background: 'white', cursor: 'pointer',
      }}
    >
      <Paperclip size={14} />
      {attachment.filename}
    </button>
  );
}

function AttachmentList({ attachments }) {
  if (!attachments || attachments.length === 0) return null;
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '6px' }}>
      {attachments.map((a) => <AttachmentPreview key={a.filename} attachment={a} />)}
    </div>
  );
}

export default AttachmentList;
